export default __webpack_public_path__ + "static/513-6cc4f50cf41b21211a76a65a206d835f.gif";